import React, { createContext, useContext, useState } from "react";

interface SidebarContextType {
  anchorEl: HTMLElement | null;
  openSidebar: (el: HTMLElement) => void;
  closeSidebar: () => void;
  isOpen: boolean;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);
export const SidebarProvider = ({ children }: { children: React.ReactNode }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const openSidebar = (el: HTMLElement) => setAnchorEl(el);
  const closeSidebar = () => setAnchorEl(null);

  return (
    <SidebarContext.Provider
      value={{
        anchorEl,
        openSidebar,
        closeSidebar,
        isOpen: Boolean(anchorEl),
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const ctx = useContext(SidebarContext);
  if (!ctx) throw new Error("useSidebar must be used inside SidebarProvider");
  return ctx;
};
